import { routes } from 'lib/routes';

import Error404 from '../components/04-templates/404';

const Learn404 = () => <Error404 routes={routes} />;

export default Learn404;
